export const DOCUMENT_ID_PARAM = ':documentId';
export const DOCUMENT_VERSION_PARAM = ':documentVersion';

export const DOCUMENT_RESULTS_PAGE = `/results/${DOCUMENT_ID_PARAM}/${DOCUMENT_VERSION_PARAM}`;

export const PQA_ACCURACY_UI_PAGE = `/pqa-accuracy-ui`;
export const PQA_ACCURACY_PAGE = `/pqa-accuracy`;

export const NOT_FOUND_PAGE = '/404';
